import $ from 'jquery';

$(function() {
    const $filter = $('#directory-filter');
    if ($filter.length) {
        $filter.find('input[type="submit"]').click(function(event) {
            filterDirectory($filter, event);
        });
    }
});

function filterDirectory($filter, e) {
    e.preventDefault();
    const userType = $filter.find('#userType').val();
    const orgType = $filter.find('#orgType').val();
    const service = $filter.find('#service').val();
    const state = $filter.find('#state').val();
    const postalCode = $filter.find('#postalCode').val();
    const postalCodeRadius = $filter.find('#postalCodeRadius').val();
    const search = $filter.find('#search').val();
    const $results = $('#results');
    const spinnerHtml = '<div class="spinner">' +
                            '<div class="double-bounce1"></div>' +
                            '<div class="double-bounce2"></div>' +
                        '</div>';

    let data = {
        userType: userType,
        orgType: orgType,
        service: service,
        state: state,
        postalCode: postalCode,
        postalCodeRadius: postalCodeRadius,
        search: search
    };
    
    data[window.csrfTokenName] = window.csrfTokenValue;

    $.ajax({
        type: "POST",
        data: data,
        url: '/actions/rebateProcessor/directory/searchDirectory',
        success: function(response) {
            $results.html(response);
        },
        beforeSend: function() {
            $results.html(spinnerHtml);
        }
    });
}
